import { useCallback, useRef, useState } from 'react';

/** A new organization visit invalidates both its record and all old setters. */
export function useScopedMerchant(scope) {
  const visit = useRef({ scope, generation: 0 });
  if (visit.current.scope !== scope)
    visit.current = { scope, generation: visit.current.generation + 1 };
  const generation = visit.current.generation;
  const [record, setRecord] = useState(null);
  const setMerchant = useCallback(
    (value) => {
      if (visit.current.generation !== generation) return;
      setRecord((previous) => {
        if (visit.current.generation !== generation) return previous;
        const data =
          typeof value === 'function'
            ? value(previous?.generation === generation ? previous.data : null)
            : value;
        if (data?.clerkOrganizationId && scope && data.clerkOrganizationId !== scope)
          return previous;
        return { generation, data };
      });
    },
    [generation, scope],
  );
  return [record?.generation === generation ? record.data : null, setMerchant];
}
